import React, { useState, useEffect, useRef } from "react";

// Examples:
{
  /* <SimpleTransitionBoth
key="hi"
transitionBaseClass="slide-in-up-pre mb-5"
transitionEndClass="slide-in-up"
duration="1s"
// delay={1200}
>
Class
</SimpleTransitionBoth>
<SimpleTransitionBoth
// key="hei"
transitionBaseClass="fade"
transitionEndClass="show"
duration="2s" //duration of classes can be overwritten as such
>
Bootstrap Class
</SimpleTransitionBoth>
<SimpleTransitionBoth
// key="hezi"
transitionBaseStyle={{
  transitionDuration: "1s",
  transform: "translateX(-30px)",
  opacity: 0,
}}
transitionEndStyle={{ transform: "translateX(0px)", opacity: 1 }}
>
Custom Transition Styles
</SimpleTransitionBoth> */
}

const SimpleTransitionBoth = ({
  children,
  //preferably pass in either transitionBaseClass and transitionEndClass OR transitionBaseStyle and transitionEndStyle
  transitionBaseClass, //Base class name for transition
  transitionEndClass = "", // Class name for transition's ending state
  transitionBaseStyle, //Base style allowing for more custom control
  transitionEndStyle, //End style
  delay = 0, //in miliseconds. may switch to transition delay or provide both as prop options. However, you can omit this and provide transitionDelay directly in the baseStyle currently, if you wish
  duration, //The duration prop will be used for transition-duration. It will overwrite any transition-duration from one of the class-based props, but be overwritten by any transition-duration passed through one of the style object props.
  triggerOnScroll,
  resetTriggerOnScroll,
  triggerOnScrollObserverOptions,
  ...props
}) => {
  const [transitionIn, setTransitionIn] = useState(false);
  const containerRef = useRef();

  useEffect(() => {
    let observer;
    let isMounted = true;
    if (!triggerOnScroll) {
      setTimeout(() => {
        if (isMounted) {
          setTransitionIn(true);
        }
      }, 20 + parseInt(delay));
    } else {
      observer = new IntersectionObserver(([observerEntry]) => {
        if (observerEntry.isIntersecting) {
          setTimeout(() => {
            if (isMounted) {
              setTransitionIn(true);
            }
          }, 20 + parseInt(delay));
        } else if (resetTriggerOnScroll && !observerEntry.isIntersecting) {
          //checking !observerEntry.isIntersection is redundant because we are in an else block for if/when it's false already, but I am choosing to be explicit
          if (isMounted) {
            setTransitionIn(false);
          }
        }
      }, triggerOnScrollObserverOptions);
      observer.observe(containerRef.current);
    }
    return () => {
      isMounted = false;
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={
        transitionBaseClass //if developer passed in transitionBaseClass, then use this logic
          ? transitionBaseClass + (transitionIn ? ` ${transitionEndClass}` : "")
          : ""
      }
      style={
        transitionBaseStyle //if developer passed in transitionBaseStyle, use this method
          ? {
              transitionDuration: duration, //if duration is passed in as a separate prop and not as part of the transition style object props, this will be used. Otherwise it will be overwritten by the duration in those objects. Either way, the element should probably have a transition duration set somewhere.
              ...transitionBaseStyle,
              ...(transitionIn ? transitionEndStyle : {}),
            }
          : { transitionDuration: duration }
      }
      {...props}
    >
      {children}
    </div>
  );
};

export default SimpleTransitionBoth;
